import React, { useState } from "react";

const PayModal = ({ handlePayment }) => {
  const [amount, setAmount] = useState();
  const sendPayment = (e) => {
    e.preventDefault();
    console.log("Sent");
    console.log(amount);
    handlePayment(amount);
  };
  return (
    <div className="flex flex-col items-center gap-6">
      <h2 className="text-black text-4xl">Pay</h2>
      {/*<input
        placeholder="Wallet Adress"
        className="w-[70%] text-xl border border-black py-3 px-3 rounded-lg"
  />*/}
      <form onSubmit={(event) => sendPayment(event)}>
        <input
          placeholder="Amount"
          className="w-[70%] text-xl border border-black py-3 px-3 rounded-lg"
          onChange={(e) => setAmount(e.target.value)}
        />
        <button
          type="submit"
          className="rounded-full px-12 py-2 bg-[#9a86f3] text-2xl cursor-pointer"
          /*onClick={() => handlePayment()}*/
        >
          Pay
        </button>
      </form>
    </div>
  );
};

export default PayModal;
